<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="12" class="text-center text-sm-left flex-header">
                <h3 class="page-title">
                    Klient
                    <a href="#" @click.prevent="closeCustomView">
                        <template v-if="client.type === 'corporation'">{{ client.company_name }}</template>
                        <template v-else>{{ client.name }} {{ client.surname }}</template>
                    </a>
                </h3>
                <d-button
                    v-if="!isCustomView"
                    theme="secondary"
                    @click.prevent="backToList()">
                    <i class="material-icons">keyboard_backspace</i> Wróć do listy
                </d-button>
                <d-button
                    v-if="isCustomView"
                    @click.prevent="closeCustomView">
                    <i class="material-icons">close</i> Zamknij
                </d-button>
                <d-button
                    v-else
                    theme="success"
                    @click.prevent="submitForm">
                    <i class="material-icons">save</i> Zapisz zmiany
                </d-button>
                <d-button
                    v-if="showNewGuarantorForm"
                    :class="{ isLoading: guarantor_submitting }"
                    theme="success"
                    @click.prevent="addGuarantor">
                    <i class="material-icons">add</i> Dodaj poręczyciela
                </d-button>
                <d-button
                    v-if="showGuarantorForm"
                    :class="{ isLoading: guarantor_submitting }"
                    theme="success"
                    @click.prevent="saveGuarantor">
                    <i class="material-icons">save</i> Zapisz poręczyciela
                </d-button>
                <d-button
                    v-if="showNewGuaranteeForm"
                    :class="{ isLoading: guarantee_submitting }"
                    theme="success"
                    @click.prevent="saveGuarantee(false)">
                    <i class="material-icons">add</i> Dodaj zabezpieczenie
                </d-button>
                <d-button
                    v-if="showGuaranteeForm"
                    :class="{ isLoading: guarantee_submitting }"
                    theme="success"
                    @click.prevent="saveGuarantee(true)">
                    <i class="material-icons">save</i> Zapisz zabezpieczenie
                </d-button>
                <d-button
                    v-if="showNewDocumentForm"
                    :class="{ isLoading: document_submitting }"
                    theme="success"
                    @click.prevent="addDocument">
                    <i class="material-icons">add</i> Dodaj dokument
                </d-button>
                <!--<d-button v-if="showNewContractForm" :class="{ isLoading: new_contract_save }" theme="success" @click.prevent="addContract">Dodaj umowę</d-button>-->
            </d-col>
        </d-row>

        <div v-if="!isAllDataLoaded">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card
                v-if="showNewGuarantorForm"
                class="card-small mb-5">
                <d-list-group flush @keyup.enter="addGuarantor">
                    <d-form>
                        <d-card-header class="border-bottom">
                            <h6 class="m-0">Dane nowego poręczyciela</h6>
                        </d-card-header>
                        <guarantor :props.sync="guarantor"></guarantor>
                    </d-form>
                </d-list-group>
            </d-card>

            <d-card
                v-else-if="showGuarantorForm"
                class="card-small mb-5">
                <d-list-group flush @keyup.enter="saveGuarantor">
                    <d-form>
                        <d-card-header class="border-bottom">
                            <h6 class="m-0">Dane poręczyciela {{ guarantor_name }} {{ guarantor_surname }}</h6>
                        </d-card-header>
                        <guarantor :props.sync="guarantor_edited"></guarantor>
                    </d-form>
                </d-list-group>
            </d-card>

            <d-card
                v-else-if="showNewGuaranteeForm"
                class="card-small mb-5">
                <d-list-group
                    flush
                    @keyup.enter="saveGuarantee(false)">
                    <d-form>
                        <d-card-header class="border-bottom">
                            <h6 class="m-0">Dane nowego zabezpieczenia</h6>
                        </d-card-header>
                        <d-list-group flush>
                            <d-list-group-item class="p-3">
                                <guarantee-form
                                    ref="guarantee-form"
                                    :guarantors="guarantors"
                                    @guarantee-updated="loadGuarantees">
                                </guarantee-form>
                            </d-list-group-item>
                        </d-list-group>
                    </d-form>
                </d-list-group>
            </d-card>

            <d-card
                v-else-if="showGuaranteeForm"
                class="card-small mb-5">
                <d-list-group
                    flush
                    @keyup.enter="saveGuarantee(true)">
                    <d-form>
                        <d-card-header class="border-bottom">
                            <h6 class="m-0">Dane zabezpieczenia</h6>
                        </d-card-header>
                        <d-list-group flush>
                            <d-list-group-item class="p-3">
                                <guarantee-form
                                    ref="guarantee-form-edit"
                                    :guarantee-prop="guarantee_edited"
                                    :guarantors="guarantors"
                                    @guarantee-updated="loadGuarantees">
                                </guarantee-form>
                            </d-list-group-item>
                        </d-list-group>
                    </d-form>
                </d-list-group>
            </d-card>

            <d-card
                v-else-if="showNewDocumentForm"
                class="card-small mb-5">
                <d-list-group flush @keyup.enter="saveDocument">
                    <d-form>
                        <d-card-header class="border-bottom">
                            <h6 class="m-0">Nowy dokument</h6>
                        </d-card-header>
                        <document :props.sync="document"></document>
                    </d-form>
                </d-list-group>
            </d-card>

            <d-card
                v-else-if="showNewContractForm"
                class="card-small mb-5">
                <d-list-group flush>
                    <d-form>
                        <contract-new
                            v-if="client.id"
                            @contractSaved="contractSavedHandler"
                            :save="new_contract_save"
                            :guarantors="guarantors"
                            :guarantees="guarantees"
                            :documents="documents"
                            :is-contract-internal="isClientInternal"
                            :client-id="Number(client.id)" />
                    </d-form>
                </d-list-group>
            </d-card>

            <d-card
                v-else-if="isAllDataLoaded"
                class="card-small mb-5">
                <d-list-group flush @keyup.enter="submitForm">
                    <d-form>
                        <div class="ss-tabs-wrapper">
                            <ul class="ss-tabs-nav">
                                <li :class="{ active: activeTab === 0, 'has-error': hasErrorsTabPersonal}"
                                    @click="activeTab = 0"><span>Dane podstawowe</span></li>
                                <li :class="{ active: activeTab === 1, 'has-error': hasErrorsTabAddress}"
                                    @click="activeTab = 1"><span>Dane korespondencyjne</span></li>
                                <li :class="{ active: activeTab === 2, 'has-error': hasErrorsTabAddress}"
                                    @click="activeTab = 2"><span>Poręczyciele</span></li>
                                <li :class="{ active: activeTab === 3}"
                                    @click="activeTab = 3"><span>Zabezpieczenia</span></li>
                                <li :class="{ active: activeTab === 4}"
                                    @click="activeTab = 4"><span>Dokumenty</span></li>
                                <li :class="{ active: activeTab === 5}"
                                    @click="activeTab = 5"><span>Umowy</span></li>
<!--                                <li :class="{ active: activeTab === 6}"-->
<!--                                    @click="activeTab = 6"><span>Historia kontaktu</span></li>-->
                            </ul>
                            <ul class="ss-tabs">
                                <li class="active" v-if="activeTab === 0">
                                    <d-card-header class="border-bottom">
                                        <h6 class="m-0">Podstawowe dane klienta</h6>
                                    </d-card-header>
                                    <personal-data
                                        ref="personalData"
                                        :props="client"
                                        :representatives="representatives" />
                                </li>
                                <li class="active" v-if="activeTab === 1">
                                    <d-row>
                                        <d-col>
                                            <d-card-header class="border-bottom flex-header">
                                                <h6 class="m-0">Dane siedziby</h6>
                                                <d-button @click.prevent="copyBusinessData"><i class="material-icons">filter_none</i> Kopiuj dane adresowe</d-button>
                                            </d-card-header>
                                            <address-business :props="client" />
                                            <d-card-header class="border-bottom flex-header">
                                                <h6 class="m-0">Dane korespondencyjne</h6>
                                                <d-button @click.prevent="copyInvoiceData"><i class="material-icons">filter_none</i> Kopiuj dane do faktury</d-button>
                                            </d-card-header>
                                            <address-data :props="client" />
                                        </d-col>
                                        <d-col>
                                            <d-card-header class="border-top">
                                                <h6 class="m-0">Dane do faktury</h6>
                                            </d-card-header>
                                            <invoice-data :props="client" />
                                        </d-col>
                                    </d-row>
                                </li>
                                <li class="active" v-if="activeTab === 2">
                                    <d-card-header class="border-bottom flex-header">
                                        <h6 class="m-0">Lista poręczycieli</h6>
                                        <d-button @click.prevent="showNewGuarantorForm = true" theme="success"><i class="material-icons">add</i> Dodaj poręczyciela</d-button>
                                    </d-card-header>
                                    <guarantors-list @removeGuarantor="removeGuarantorHandler"
                                                     @editGuarantor="editGuarantorHandler"
                                                     :props="guarantors" />
                                </li>
                                <li class="active" v-if="activeTab === 3">
                                    <d-card-header class="border-bottom flex-header">
                                        <h6 class="m-0">Lista zabezpieczeń</h6>
                                        <d-button @click.prevent="showNewGuaranteeForm = true" theme="success"><i class="material-icons">add</i> Dodaj zabezpieczenie</d-button>
                                    </d-card-header>
                                    <guarantees-list @removeGuarantee="removeGuaranteeHandler"
                                                     @editGuarantee="editGuaranteeHandler"
                                                     :props="guarantees" />
                                </li>
                                <li class="active" v-if="activeTab === 4">
                                    <d-card-header class="border-bottom flex-header">
                                        <h6 class="m-0">Lista dokumentów</h6>
                                        <d-button @click.prevent="showNewDocumentForm = true" theme="success"><i class="material-icons">add</i> Dodaj dokument</d-button>
                                    </d-card-header>
                                    <documents-list @removeDocument="removeDocumentHandler"
                                                     :props="documents" />
                                </li>

                                <li class="active" v-if="activeTab === 5">
                                    <d-card-header class="border-bottom flex-header">
                                        <h6 class="m-0">Lista umów</h6>
                                        <d-button @click.prevent="showNewContractForm = true" theme="success"><i class="material-icons">add</i> Dodaj umowę</d-button>
                                    </d-card-header>
                                    <contracts-list
                                        :props="schedules"
                                        @removeContract="removeContractHandler()"
                                        @editSchedule="editContractHandler" />
                                </li>
                            </ul>
                        </div>
                    </d-form>
                </d-list-group>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import SsPopover from '../components/common/SsPopover'
    import LarErrors from '../helpers/Errors';
    import AddressData from '../components/client/AddressData'
    import AddressBusiness from '../components/client/AddressBusiness'
    import AddressResidence from '../components/client/AddressResidence'
    import InvoiceData from '../components/client/InvoiceData'
    import PersonalData from '../components/client/PersonalData'
    import GuarantorsList from '../components/client/GuarantorsList'
    import Guarantor from '../components/client/Guarantor'
    import GuaranteesList from '../components/client/GuaranteesList'
    import DocumentsList from "../components/client/DocumentsList";
    import Document from "../components/client/Document";
    import ClientUtils from '../utils/client';
    import ContractsList from "../components/client/ContractsList";
    import ContractEdit from '../components/client/ContractEdit';
    import ContractNew from '../components/client/ContractNew';
    import FormUtils from '@/utils/FormUtils.js';
    import GuaranteeForm from '@/components/client/GuaranteeForm.vue';
    import GuaranteeUtils from '@/utils/guarantee.js';

    export default {
        name: 'ClientEdit',
        components: {
            ContractsList,
            ContractNew,
            Document,
            DocumentsList,
            LarErrors,
            AddressData,
            AddressBusiness,
            AddressResidence,
            InvoiceData,
            PersonalData,
            GuarantorsList,
            Guarantor,
            GuaranteesList,
            SsPopover,
            ContractEdit,
            GuaranteeForm
        },
        data(){
            return{
                lar_errors:             LarErrors,
                redirected:             false,
                activeTab:              0,
                new_contract_save:      false,
                copy:                   false,
                fetched:                false,
                fetched_schedules:      false,
                fetched_schedule:       false,
                fetched_representatives:      false,
                representatives:        [],
                submitting:             false,
                showGuarantorForm:      false,
                showNewGuarantorForm:   false,
                guarantor_submitting:   false,
                accept_contract:        false,
                guarantor_name:         '',
                guarantor_surname:      '',
                guarantor:              ClientUtils._guarantor,
                guarantor_edited:       ClientUtils._guarantor,
                guarantors:             [],
                showGuaranteeForm:      false,
                showNewGuaranteeForm:   false,
                guarantee_submitting:   false,
                guarantee:              ClientUtils._guarantee,
                guarantee_edited:       ClientUtils._guarantee,
                guarantees:             [],
                guaranteesLoaded:       false,
                showNewDocumentForm:    false,
                document_submitting:    false,
                document:               ClientUtils._document,
                documents:              [],
                contact_submitting:     false,
                contact:                ClientUtils._contact,
                contact_edited:         ClientUtils._contact,
                contact_history:        [],
                contract_submitting:     false,
                contract:                ClientUtils._contract,
                contract_edited:         ClientUtils._contract,
                contract_history:        [],
                showNewContractForm:      false,
                schedules: [],
                contract_save:            false,
                client: {
                    name:       '',
                    company_name: '',
                    surname:    '',
                    email:      '',
                    phone:      '',
                    id_card:    '',
                    id_card_type:'id',
                    pesel:      '',
                    nip:        '',
                    company_id: null,
                    invoice_name:       '',
                    invoice_address:    '',
                    invoice_city:       '',
                    invoice_postcode:   '',
                    invoice_tax_number: '',
                    invoice_street:     '',
                    invoice_house_number: '',
                    invoice_flat_number: '',
                    correspondence_street:          '',
                    correspondence_house_number:    '',
                    correspondence_flat_number:    '',
                    correspondence_postcode:        '',
                    correspondence_city:            '',
                    residence_street:               '',
                    residence_house_number:         '',
                    residence_flat_number:         '',
                    residence_postcode:             '',
                    residence_city:                 '',
                    business_street:                '',
                    business_house_number:          '',
                    business_flat_number:          '',
                    business_postcode:              '',
                    business_city:                  '',
                    is_second_person:   '0',
                    second_name:        '',
                    second_surname:     '',
                    second_email:       '',
                    second_phone:       '',
                    second_pesel:       '',
                    second_id_card:     '',
                    second_id_card_type:'id',
                    second_type:        '',
                    second_residence_street:        '',
                    second_residence_house_number:  '',
                    second_residence_flat_number:  '',
                    second_residence_postcode:      '',
                    second_residence_city:          '',
                    second_person_marital_status:          null,
                    second_person_marital_status_other:    '',
                    second_person_property_separation:     null,
                    client_internal:               '0',
                    marital_status:                null,
                    marital_status_other:          ''
                },
                loadError: false
            }
        },
        computed:{
            ...mapGetters([
                'allCompanies',
                'getUser'
            ]),
            isAllDataLoaded () {
                return this.fetched && this.fetched_schedules && this.fetched_representatives;
            },
            isCustomView(){
              return this.showGuarantorForm ||
                      this.showNewGuarantorForm ||
                      this.showGuaranteeForm ||
                      this.showNewGuaranteeForm ||
                      this.showNewDocumentForm ||
                      this.showNewContractForm;
            },
            hasErrorsTabPersonal() {
                return this.lar_errors.errors.name ||
                    this.lar_errors.errors.surname ||
                    this.lar_errors.errors.email ||
                    this.lar_errors.errors.phone ||
                    this.lar_errors.errors.company_id
            },
            hasErrorsTabAddress() {
                return this.lar_errors.errors.correspondence_street ||
                    this.lar_errors.errors.correspondence_house_number ||
                    this.lar_errors.errors.correspondence_postcode ||
                    this.lar_errors.errors.correspondence_city ||
                    this.lar_errors.errors.invoice_name ||
                    this.lar_errors.errors.invoice_address ||
                    this.lar_errors.errors.invoice_city ||
                    this.lar_errors.errors.invoice_postcode
            },
            isClientInternal () {
                if (!this.client) {
                    return false;
                }
                return !!Number(this.client.client_internal);
            }
        },
        methods: {
            ...mapActions([
                'getAllCompanies'
            ]),
            backToList(){
                this.$router.push({name: this.$route.params.from ? this.$route.params.from : 'clients-list'})
            },
            copyInvoiceData(){
                this.client.correspondence_city = this.client.invoice_city;
                this.client.correspondence_street = this.client.invoice_street;
                this.client.correspondence_house_number = this.client.invoice_house_number;
                this.client.correspondence_flat_number = this.client.invoice_flat_number;
                this.client.correspondence_postcode = this.client.invoice_postcode;
                this.$forceUpdate();
            },
            copyResidenceData(){
                this.client.residence_city = this.client.correspondence_city;
                this.client.residence_street = this.client.correspondence_street;
                this.client.residence_house_number = this.client.correspondence_house_number;
                this.client.residence_flat_number = this.client.correspondence_flat_number;
                this.client.residence_postcode = this.client.correspondence_postcode;
                this.$forceUpdate();
            },
            copyBusinessData(){
                this.client.business_city = this.client.correspondence_city;
                this.client.business_street = this.client.correspondence_street;
                this.client.business_house_number = this.client.correspondence_house_number;
                this.client.business_flat_number = this.client.correspondence_flat_number;
                this.client.business_postcode = this.client.correspondence_postcode;
                this.$forceUpdate();
            },
            contractEditedFetched(contract){
              this.contract_edited = contract;
            },
            editContractHandler (contract) {
                this.$router.push({
                    name: 'contract-edit',
                    params: {
                        client_id: this.$route.params.id,
                        schedule_id: contract.id,
                        case_id: this.$route.params.case_id || null,
                        client: this.client
                    }
                });
            },
            contractSavedHandler(){
                this.new_contract_save = false;
                this.loadSchedules();
                this.closeCustomView();
            },
            scheduleChangedHandler() {
                this.$forceUpdate();
            },
            loadSchedules () {
                FormUtils.loadAdditionalData(this, {
                    endpoint: '/api/schedules/get-schedules',
                    method: 'post',
                    outputKey: 'schedules',
                    loadedKey: 'fetched_schedules',
                    errorKey: 'loadError',
                    params: {
                        noPagination: true,
                        search: {
                            client_id: this.$route.params.id
                        },
                        short: true
                    }
                });
            },
            loadGuarantors (shouldCloseModal = true) {
                axios.post('api/guarantors/get-guarantors', {client_id: this.$route.params.id}).then(response => {
                    this.guarantors = response.data.guarantors;
                    if (shouldCloseModal) {
                        this.closeCustomView();
                    }
                }).catch(errors => {
                    console.log(errors);
                    if (shouldCloseModal) {
                        this.closeCustomView();
                    }
                })
            },
            loadGuarantees (shouldCloseModal = true){
                FormUtils.loadAdditionalData(this, {
                    endpoint: '/api/payment-guarantees/get-payment-guarantees',
                    method: 'post',
                    responseKey: 'payment_guarantees',
                    outputKey: 'guarantees',
                    loadedKey: 'guaranteesLoaded',
                    errorKey: 'loadError',
                    noPagination: true,
                    booleanFields: ['is_burdens_on_property'],
                    params: {
                        client_id: this.$route.params.id
                    },
                    successAction: () => {
                        if (shouldCloseModal) {
                            this.closeCustomView();
                        }
                    },
                    failAction: () => {
                        if (shouldCloseModal) {
                            this.closeCustomView();
                        }
                    }
                });
            },
            loadContactHistory(){
                axios.post('api/contact-history/get-client-history', {client_id: this.$route.params.id}).then(response => {
                    this.contact_history = response.data.contact_history;
                    this.closeCustomView();
                }).catch(errors => {
                    console.log(errors);
                    this.closeCustomView();
                })
            },
            loadDocuments(){
                axios.post('api/clients/get-documents', {client_id: this.$route.params.id}).then(response => {
                    this.documents = response.data.documents;
                    this.closeCustomView();
                }).catch(errors => {
                    console.log(errors);
                    this.closeCustomView();
                })
            },
            addDocument(){
                var data = new FormData();
                Vue.appendFormdata(data, this.document);

                this.document_submitting = true;
                axios.post('api/clients/save-document', data).then(response => {
                    Vue.swal({
                        type: 'success',
                        title: 'Dokument został dodany.',
                        showConfirmButton: true,
                    }).then(() => {
                        this.document = {
                          id:         '',
                          name:       '',
                          client_id:  this.client.id,
                          type:       '',
                          file:       null
                        };
                        this.loadDocuments();
                        this.$forceUpdate();
                    });
                    this.document_submitting = false;
                }).catch((error) =>{
                    this.document_submitting = false;
                    console.log(error);
                    LarErrors.record(error.response.data.errors)
                })
            },
            closeCustomView(){
                this.showGuarantorForm = false;
                this.showNewGuarantorForm = false;
                this.showGuaranteeForm = false;
                this.showNewGuaranteeForm = false;
                this.showNewDocumentForm = false;
                this.showNewContractForm = false;
            },
            removeGuarantorHandler(){
                this.loadGuarantors();
            },
            removeGuaranteeHandler(){
                this.loadGuarantees();
            },
            removeDocumentHandler(){
                this.loadDocuments();
            },
            removeContractHandler(){
                this.loadSchedules();
            },
            editGuaranteeHandler(guarantee){
                this.guarantee_edited = _.clone(guarantee);
                this.showGuaranteeForm = true;
            },
            async saveGuarantee (isEdit = true) {
                try {
                    this.guarantee_submitting = true;
                    let guaranteeForm = null;
                    if (isEdit) {
                        guaranteeForm = this.$refs['guarantee-form-edit'];
                    } else {
                        guaranteeForm = this.$refs['guarantee-form'];
                    }

                    const isValid = await guaranteeForm.validateForm();
                    if (!isValid) {
                        this.guarantee_submitting = false;
                        return
                    }

                    GuaranteeUtils.saveGuarantee(guaranteeForm.guarantee, this.client.id, this.saveGuaranteeSuccessHandler, this.saveGuaranteeFailHandler);
                } catch (error) {
                    this.guarantee_submitting = false;
                    console.error('Error validating form:', error);
                }
            },
            saveGuaranteeSuccessHandler () {
                this.guarantee_submitting = false;
                this.loadGuarantees();
            },
            saveGuaranteeFailHandler (error) {
                console.error(error);
                this.guarantee_submitting = false;
                if (error && error.response && error.response.data && error.response.data.errors) {
                    LarErrors.record(error.response.data.errors)
                }
            },
            editGuarantorHandler(guarantor){
                this.guarantor_edited = _.clone(guarantor);
                this.guarantor_name = guarantor.name;
                this.guarantor_surname = guarantor.surname;
                this.showGuarantorForm = true;
            },
            saveGuarantor(){
                this.guarantor_submitting = true;
                axios.post('api/guarantors/save-guarantor', this.guarantor_edited).then(response => {
                    Vue.swal({
                        type: 'success',
                        title: 'Poręczyciel został zapisany.',
                        showConfirmButton: true,
                    }).then(() => {
                        this.loadGuarantors();
                    });
                    this.guarantor_submitting = false;
                }).catch((error) =>{
                    Vue.swal({
                        type: 'error',
                        title: error.response.data.message,
                        html: Vue.transformErrorsToHtml(error.response.data.errors),
                        showConfirmButton: true,
                    });
                    this.guarantor_submitting = false;
                    LarErrors.record(error.response.data.errors)
                })
            },
            addGuarantor(){
                this.guarantor_submitting = true;
                axios.post('api/guarantors/save-guarantor', this.guarantor).then(response => {
                    Vue.swal({
                        type: 'success',
                        title: 'Poręczyciel został dodany.',
                        showConfirmButton: true,
                    }).then(() => {
                        this.loadGuarantors();
                        this.closeCustomView();
                    });
                    this.guarantor_submitting = false;
                }).catch((error) =>{
                    Vue.swal({
                        type: 'error',
                        title: error.response.data.message,
                        html: Vue.transformErrorsToHtml(error.response.data.errors),
                        showConfirmButton: true,
                    });
                    this.guarantor_submitting = false;
                    LarErrors.record(error.response.data.errors)
                })
            },
            fetchData(){
                axios.post('api/clients/get-client', {id: this.$route.params.id}).then(response => {
                    this.client = response.data.data;

                    if (typeof this.client.is_second_person === 'number') {
                        this.client.is_second_person = this.client.is_second_person.toString();
                    }

                    if (this.client.is_second_person === '') {
                        this.client.is_second_person = '0';
                    }

                    if (typeof this.client.client_internal === 'number') {
                        this.client.client_internal = this.client.client_internal.toString();
                    }

                    if (this.client.client_internal === '') {
                        this.client.client_internal = '0';
                    }

                    this.getAllCompanies();
                    this.loadGuarantees();
                    this.loadGuarantors();
                    this.loadDocuments();
                    this.loadSchedules();
                    this.loadRepresentatives();
                    this.fetched = true;
                }).catch(errors => {
                    console.log(errors);
                    this.fetched = true;
                })
            },
            submitForm(){
                if (this.client.type === 'corporation') {
                    this.client.representatives = this.$refs.personalData.getRepresentatives();
                }

                axios.post('api/clients/save-client', this.client).then(response => {
                    Vue.swal({
                        type: 'success',
                        title: 'Zmiany zostały zapisane.',
                        showConfirmButton: true,
                    }).then(() => {
                        this.fetchData();
                    });
                }).catch((error) =>{
                    Vue.swal({
                        type: 'error',
                        title: error.response.data.message,
                        html: Vue.transformErrorsToHtml(error.response.data.errors),
                        showConfirmButton: true,
                    });
                    LarErrors.record(error.response.data.errors)
                })
            },
            setContractAccepted () {
                this.accept_contract = false;
            },
            setContractSaved (newValue = false) {
                this.contract_save = newValue;
            },
            loadRepresentatives () {
                this.fetched_representatives = false;
                if (this.client.type !== 'corporation' || !this.client.representatives.length) {
                    this.fetched_representatives = true;
                    return;
                }
                this.fetched_representatives = false;
                let where = { ids: this.client.representatives };

                FormUtils.loadAdditionalData(this, {
                    endpoint: '/api/representatives/get-representatives',
                    method: 'post',
                    outputKey: 'representatives',
                    loadedKey: 'fetched_representatives',
                    errorKey: 'loadError',
                    noPagination: false,
                    params: { where },
                });
            },
        },
        mounted(){
            // TO prawdopodobnie w dodawaniu jest potrzebne
            this.$bus.$on('client-reload-gurantees', this.loadGuarantees);

            ClientUtils._guarantor.client_id = this.$route.params.id;
            this.guarantor = _.clone(ClientUtils._guarantor, true);
            ClientUtils._guarantee.client_id = this.$route.params.id;
            this.guarantee = _.clone(ClientUtils._guarantee, true);
            ClientUtils._document.client_id = this.$route.params.id;
            this.document = _.clone(ClientUtils._document, true);
            ClientUtils._contact.client_id = this.$route.params.id;
            this.contact = _.clone(ClientUtils._contact, true);
            this.fetchData();
        },
        watch: {
            activeTab(){
                this.lar_errors.clear();
            },
            isCustomView(){
                this.lar_errors.clear();
            },
            showNewGuarantorForm(to){
                if(!to){
                    this.guarantor = _.clone(ClientUtils._guarantor, true);
                }
            },
            showNewGuaranteeForm(to){
                if(!to){
                    this.guarantee = _.clone(ClientUtils._guarantee, true);
                }
            }
        },
        beforeDestroy () {
            this.$bus.$off('client-reload-gurantees', this.loadGuarantees);
        }
    }
</script>
